import { IApiKey } from '@/features/apikeys/apikeySlice'
import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'

export const getKeys = async (params?: any): Promise<IApiResponse<IList<IApiKey>>> => {
	const { data } = await axios.get<IApiResponse<IList<IApiKey>>>('/api/api-key', { params })
	return data
}

export const updateKey = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.put<IApiResponse<null | undefined>>('/api/api-key', params)
	return data
}

export const removeKey = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.delete<IApiResponse<null | undefined>>('/api/api-key', { params })
	return data
}

export const addKey= async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.post<IApiResponse<null | undefined>>('/api/api-key', params)
	return data
}